export default "__VITE_ASSET__CeCg7mn7__"